document.addEventListener('DOMContentLoaded', function() {
  function addButtonStyles() {
    const formRoot = document.querySelector('[data-forms-id="forms-root-667851"]');
    if (!formRoot) return;

    const formEmbed = formRoot.querySelector('shopify-forms-embed');
    if (!formEmbed) return;

    const shadowRoot = formEmbed.shadowRoot;
    if (!shadowRoot) return;

    // Avoid adding duplicate style tags
    if (!shadowRoot.querySelector('#custom-submit-button-style')) {
      const styleEl = document.createElement('style');
      styleEl.id = 'custom-submit-button-style';
      styleEl.textContent = `
          div._formDisclaimer_cit2d_38 p , div._formDisclaimer_cit2d_38 a{ color: rgb(var(--color-button)) !important; }
          div._formDisclaimer_cit2d_38 a{ text-decoration:none; }
        ._inline_1q1d2_47 ._formContainer_1q1d2_30{ overflow:visible; max-width:100% !important;}
        button._formSubmitButton_cit2d_96 { display: flex !important; }
      `;
      shadowRoot.appendChild(styleEl);
      console.log('Custom styles applied to submit button.');
    }
  }
  addButtonStyles();
  const observer = new MutationObserver(() => addButtonStyles());
  observer.observe(document.body, { childList: true, subtree: true });
});
